import React, {useEffect, useState} from "react";
import SideDrawer from "../../../Components/Advertisers/SideDrawer";
import {
  Avatar, Backdrop, Button, CircularProgress,
  Container, Divider, Grid, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, makeStyles,
} from "@material-ui/core";
import CustomText from "../../../Components/Universal/CustomText";
import {Alert} from "@material-ui/lab";
import groupIcon from "../../../Assets/group.png";
import moment from "moment";
import useAxios from "axios-hooks";
import {getCustomerLists, removeCustomerList} from "../../../Api";
import {Link} from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
  },
}));

const CustomerList = ({history}) => {
  const classes = useStyles();
  const [errorMsg, setErrorMsg] = useState('');
  const [customerLists, setCustomerLists] = useState([]);

  const [{error, loading, data}, refetchCustomerList] = useAxios(getCustomerLists(), {manual: false});
  const [{error: removeError, loading: removeLoading, data: removeData}, removeCustomerListAction] = useAxios(removeCustomerList(), {manual: true});

  useEffect(() => {
    if (data && data.customerList) {
      setCustomerLists(data.customerList);
    }
    if (error) {
      setErrorMsg('Unable to fetch data from server, please try again later.');
    }
  }, [error, data]);

  useEffect(() => {
    if (data) {
      refetchCustomerList();
    }
  }, []);

  useEffect(() => {
    if (removeData) {
      if (removeData.error) {
        setErrorMsg(removeData.message);
      } else {
        refetchCustomerList();
      }
    }

    if (removeError) {
      setErrorMsg('Unable to perform remove action, please try again later.');
    }
  }, [removeError, removeData]);

  const handleRemove = id => () => {
    if (window.confirm('Are you sure you want to remove this customer list?')) {
      removeCustomerListAction({
        data: { id },
      });
    }
  };

  return (
    <SideDrawer>
      <Container>
        <Backdrop className={classes.backdrop} open={loading || removeLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CustomText
              text={`Customer Lists`}
              style='titleLarge'
              margin='40px 0 0 0'
            >
              <Button
                color="default"
                variant="outlined"
                style={{ float: 'right' }}
                component={Link}
                to={'/advertiser/customerlists/create'}
              >
                Add New
              </Button>
            </CustomText>
          </Grid>
          <Grid item xs={12}>
            {errorMsg && errorMsg.length > 0 && (
              <Alert severity="error">{errorMsg}</Alert>
            )}
            <List className={classes.root}>
              {customerLists.map((customerList, i) => ([
                  <ListItem alignItems="center" key={customerList.customer_list_id}>
                    <ListItemAvatar>
                      <Avatar alt={customerList.name} src={groupIcon} />
                    </ListItemAvatar>
                    <ListItemText
                      primary={customerList.customer_list_name}
                      secondary={
                        <>
                          <p>{customerList.customer_list_description}</p>
                          <strong>Campaign:</strong> {customerList.campaign_question}<br />
                          <strong>Response Option:</strong> {customerList.response_text}<br />
                          <strong>Created at:</strong> {moment(customerList.customer_list_create_date).format('MMMM D ha')}<br />
                        </>
                      }
                    />
                    <ListItemSecondaryAction style={{ textAlign: 'center' }}>
                      <Button
                        aria-label="Create campaign from this"
                        color="primary"
                        variant="outlined"
                        size='small'
                        onClick={handleRemove()}
                      >
                        Create Campaign
                      </Button>
                      <div>&nbsp;</div>
                      <Button
                        aria-label="Remove customer list"
                        color="default"
                        variant="outlined"
                        size='small'
                        onClick={handleRemove(customerList.customer_list_id)}
                      >
                        Remove
                      </Button>
                    </ListItemSecondaryAction>
                  </ListItem>,
                  (i < (customerList.length - 1) && <Divider key={customerList.customer_list_id + i} variant="inset" component="li" />)
                ]
              ))}
            </List>
          </Grid>
        </Grid>
      </Container>
    </SideDrawer>
  )
};

export default CustomerList;
